import { bindActionCreators } from 'redux';
import { featureOn, connect, scrollToItem as scrollToItemAction } from '@instructure/quiz-core';
import { TakeStimulus as TakeStimulusPresenter } from './presenter';
export function mapStateToProps(state, props) {
  return {
    scrollKey: props.sessionItem.id,
    stimulusOrientationEnabled: featureOn('customizable_stimulus_orientation')
  };
}
export function mapDispatchToProps(dispatch, props) {
  return {
    scrollToItem: props.scrollToItem || bindActionCreators(scrollToItemAction, dispatch)
  };
}
export var TakeStimulus = connect(mapStateToProps, mapDispatchToProps)(TakeStimulusPresenter);
export default TakeStimulus;